import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'

import { ANALYTICS_EVENTS, useEvent, useGlobalCopyStore, useHoldingStore } from '../../common'

interface EmptyStateFooterComponentProps {
  sx?: SxProps
}

export const EmptyStateFooterComponent = ({ sx = {} }: EmptyStateFooterComponentProps) => {
  const { investments: copy } = useGlobalCopyStore()
  const { onEvent } = useEvent()
  const { setShowConnectionsWidget } = useHoldingStore()

  return (
    <Stack sx={{ alignItems: 'center', gap: 24, height: 164, p: 24, width: '100%', ...sx }}>
      <Stack
        className="inner-container"
        sx={{
          alignItems: 'center',
          gap: 8,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Text sx={{ fontWeight: 600 }} variant="body1">
          {copy.overview.investment_accounts_footer}
        </Text>
        <Text
          sx={{
            color: 'text.secondary',
            fontWeight: 400,
          }}
          variant="subtitle2"
        >
          {copy.overview.connect_more_accounts_description}
        </Text>
      </Stack>
      <Button
        onClick={() => {
          setShowConnectionsWidget(true)
          onEvent(ANALYTICS_EVENTS.ACCOUNTS_CLICK_CONNECT)
        }}
        sx={{ fontWeight: 600 }}
        variant="outlined"
      >
        {copy.overview.connect_accounts}
      </Button>
    </Stack>
  )
}
